(() => {
  const languageOpen = document.querySelector(
    ".language-popup__switcher-button"
  );
  const languageClose = document.querySelector(".language-popup__close-button");
  const languagePopup = document.querySelector(".language-popup__wrapper");
  const languageInput = document.querySelector(".language-popup__search");
  const regionName = document.querySelectorAll(".language-popup__region-name");

  if (!languageOpen || !languagePopup) return;

  languageOpen.addEventListener("click", e => {
    e.preventDefault();
    languagePopup.showModal();
  });

  languageClose.addEventListener("click", e => {
    e.preventDefault();
    languagePopup.close();
  });

  languageInput.addEventListener("input", e => {
    const searchValue = e.target.value.toLowerCase();
    const languageItems = document.querySelectorAll(".country");

    if (searchValue) {
      regionName.forEach(item => {
        item.classList.add("hidden");
      });
    } else {
      regionName.forEach(item => {
        item.classList.remove("hidden");
      });
    }

    languageItems.forEach(item => {
      const itemText = item.textContent.toLowerCase();

      if (itemText.includes(searchValue)) {
        item.classList.remove("hidden");
      } else {
        item.classList.add("hidden");
      }
    });
  });
})();
